<template>
  <delegation-form ref="delegationForm" />
</template>

<script>
import DelegationForm from "../../components/Delegation/DelegationForm";
export default {
  name: "DelegationNewFromOrderView",
  components: { DelegationForm },
  beforeRouteLeave(from, to, next) {
    this.$refs.delegationForm.beforeRouteLeave(from, to, next);
  },
  mounted() {
    this.$store.commit("Delegation/setReadonly", true);
  },
  beforeDestroy() {
    this.$store.commit("Delegation/setReadonly", false);
  }
};
</script>

<style scoped></style>
